import BrokerageDetails from './BrokerageDetails';

export default BrokerageDetails;
